import { ORDER_STATUS, ORDER_STATUS_TAGS } from '@/shared/constants/commonConstants'

export function getOrderStatusTag(status) {
  const statusLower = status?.toLocaleLowerCase()
  if (
    statusLower === ORDER_STATUS.COMPLETED ||
    statusLower === ORDER_STATUS.PARTIALLY_DELIVERED ||
    statusLower === ORDER_STATUS.DELIVERED
  ) {
    return ORDER_STATUS_TAGS.COMPLETED
  } else if (statusLower === ORDER_STATUS.CANCELLED) {
    return ORDER_STATUS_TAGS.CANCELLED
  }
  return ORDER_STATUS_TAGS.DEFAULT
}

export function formatOrderDate(dateStr) {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  const [month, day, year] = d
    .toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
    .split('/')
  return `${month} - ${day} - ${year}`
}

export function getColorTag(currentStatus, shouldApplyColor = true) {
  const errorStatuses = ['cancelled', 'danger', 'processing_failure']
  const successStatuses = ['success', 'completed', 'approved']

  if (shouldApplyColor) {
    if (errorStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'order-status-cancelled font-bold'
    } else if (successStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'order-status-completed font-bold'
    }
  } else {
    return ''
  }
}

export function getFormattedDate(dateString, timeCheck = false, separator = '/') {
  const date = new Date(dateString)

  const locale = navigator.language

  const dateFormat = new Intl.DateTimeFormat(locale)
  const formattedDate = dateFormat.formatToParts(date)

  const dateParts = formattedDate.filter(part => part.type === 'day' || part.type === 'month' || part.type === 'year')

  let formattedDateString = dateParts.map(part => part.value).join(separator)

  if (timeCheck) {
    const timeFormat = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })

    const formattedTime = timeFormat.format(date)
    formattedDateString += ` ${formattedTime}`
  }

  return formattedDateString
}

export const getSelectedRowData = (rowSelection, records) => {
  return rowSelection?.map(selection => records && records[selection?.index]) || []
}

export const copyToClipboard = value => {
  navigator.clipboard.writeText(value).catch(err => {
    console.error('Failed to copy text:', err)
  })
}

export const capitalizeWords = (str) => {
  return str
    ?.replace(/_/g, ' ') // Replace underscores with spaces
    ?.toLowerCase() // Convert to lowercase
    ?.replace(/\b\w/g, (char) => char?.toUpperCase()); // Capitalize the first letter of each word
};


export const countryCodes = {
  MEXICO: 'MX',
  COLOMBIA: 'CO',
  SPAIN: 'ES',
  SAUDI_ARABIA: 'SA',
}

export const showPaymentFeature = (countryCode) => {
  const allowedMarkets = [
    countryCodes.SAUDI_ARABIA,
    countryCodes.SPAIN,
  ];
  return allowedMarkets.includes(countryCode);
};

// 'e'/'E'/'+'/'-' produce an invalid intermediate value on <input type="number">,
// which the browser then reports as an empty string, wiping out what was typed.
export const blockInvalidNumberKeys = (event) => {
  if (['e', 'E', '+', '-'].includes(event.key)) event.preventDefault()
}

export const showEarlyPaymentFeature = (countryCode) => {
  const allowedMarkets = [
    countryCodes.SAUDI_ARABIA,
  ];
  return allowedMarkets.includes(countryCode);
};

export const showOrderTypeFeature = (countryCode) => {
  const allowedMarkets = [
    countryCodes.COLOMBIA,
    countryCodes.SPAIN
  ];
  const isOrderTypeEnabled = allowedMarkets.includes(countryCode);
  
  return isOrderTypeEnabled;
};

export const formatQuantity = (value, decimalPlaces = 3, fallback = '—') => {
  if (value === null || value === undefined) {
    return fallback;
  }
  
  // Truncate to specified decimal places without rounding
  const multiplier = Math.pow(10, decimalPlaces);
  return Math.floor(value * multiplier) / multiplier;
};

const COUNTRY_LANGUAGE_MAP = {
  MX: 'Spanish', CO: 'Spanish', GT: 'Spanish', PE: 'Spanish', EC: 'Spanish',
  AR: 'Spanish', DO: 'Spanish', CL: 'Spanish', ES: 'Spanish',
  PL: 'Polish',
  TR: 'Turkish',
  RU: 'Russian',
  RO: 'Romanian',
  PT: 'Portuguese',
  EG: 'Arabic', SA: 'Arabic',
  TH: 'Thai',
  NZ: 'English',
}

export const getLocalLanguageLabel = (countryCode) =>
  COUNTRY_LANGUAGE_MAP[countryCode] ?? 'Local'
